import { isEmpty } from '@ember/utils';
import PeopleSchemaAdapter from './base';

export default class Field extends PeopleSchemaAdapter {
  modelNamePlural = 'fields';

  queryRecord(...args: Parameters<PeopleSchemaAdapter['queryRecord']>) {
    const [, model, query] = args;
    if (!isEmpty(query.jurisdictionalId)) {
      const url = this.buildURL(
        model.modelName,
        'jurisdictionalId',
        // @ts-expect-error findRecord's overload wants a Snapshot, but the
        // default URL builder never reads it.
        null,
        'findRecord',
      );
      return this.ajax(url, 'GET', {});
    }
    return super.queryRecord(...args);
  }
}
